export const articles = [
  {
    id: '1',
    slug: 'top-star-scandal-2026',
    title: '某顶流男星深夜密会神秘女子 酒店共度8小时后独自离开',
    excerpt: '据知情人士透露，该男星近期因新剧热度正高，却在此关键时期被人拍到与一名身份不明的女子深夜同行。现场画面显示两人举止亲密，一路有说有笑进入某五星级酒店，直到次日清晨男星才独自驱车离开。',
    content: '',
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20night%20scene%20luxury%20hotel%20entrance%20with%20paparazzi%20style%20photography%20dark%20moody%20atmosphere%20cinematic%20lighting%20urban%20night%20street%20dramatic%20shadows%20film%20grain%20texture&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-07',
    viewCount: 1258000,
    commentCount: 38520,
    isHot: true,
    isTop: true,
    tags: ['顶流', '恋情曝光', '酒店密会'],
  },
  {
    id: '2',
    slug: 'wanghong-heiliao-2026',
    title: '百万粉丝网红被曝虚假人设 私下与直播间形象判若两人',
    excerpt: '近期有网友扒出某带货网红的真实生活照，与其直播间精心打造的人设形成鲜明对比。该网红此前以"邻家女孩"形象吸粉无数，但被曝光的私下照片却展现了完全不同的生活状态。',
    content: '',
    category: 'wanghong-heiliao',
    categoryName: '网红黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=Influencer%20livestreaming%20studio%20setup%20with%20ring%20light%20contrast%20dramatic%20lighting%20before%20and%20after%20concept%20social%20media%20persona%20moody%20cinematic%20photography%20warm%20tones&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '爆料小能手',
    publishDate: '2026-07-06',
    viewCount: 987000,
    commentCount: 28900,
    isHot: true,
    isTop: false,
    tags: ['网红', '人设崩塌', '直播翻车'],
  },
  {
    id: '3',
    slug: '911-exclusive-insider',
    title: '911独家：某知名导演剧组内幕曝光 选角环节暗藏潜规则',
    excerpt: '911爆料网独家获悉，某知名导演的新片选角过程中存在诸多不为人知的内幕。多位参与选角的演员匿名透露了试镜过程中的种种不合理要求，引发业内广泛关注。',
    content: '',
    category: '911-baoliao',
    categoryName: '911爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20casting%20audition%20room%20dramatic%20lighting%20empty%20chair%20spotlight%20cinematic%20atmosphere%20mysterious%20tension%20professional%20photography%20dark%20moody%20tones%20film%20set%20behind%20scenes&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '911爆料组',
    publishDate: '2026-07-06',
    viewCount: 1850000,
    commentCount: 56200,
    isHot: true,
    isTop: true,
    tags: ['导演', '选角内幕', '911独家'],
  },
  {
    id: '4',
    slug: '51-hot-search-gossip',
    title: '51爆料网实锤：某女星与经纪人恋情曝光 双方已同居半年',
    excerpt: '51爆料网通过多方渠道证实，某当红女星已与自己的经纪人秘密交往超过半年。两人不仅在事业上形影不离，私下也被多次拍到出入同一住所。',
    content: '',
    category: '51-baoliao',
    categoryName: '51爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20walking%20together%20on%20street%20night%20scene%20paparazzi%20style%20long%20lens%20photography%20urban%20night%20atmosphere%20dramatic%20lighting%20romantic%20mysterious%20mood&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '51爆料侠',
    publishDate: '2026-07-05',
    viewCount: 1540000,
    commentCount: 48200,
    isHot: true,
    isTop: false,
    tags: ['女星', '经纪人', '地下恋情'],
  },
  {
    id: '5',
    slug: '91-star-divorce-truth',
    title: '91爆料网深度起底：明星夫妻离婚内幕 财产分割暗藏玄机',
    excerpt: '91爆料网近日收到知情人士爆料，某知名明星夫妻的离婚案远比表面看起来复杂。涉及数亿元财产的分割方案中隐藏着多条不为外人所知的秘密协议。',
    content: '',
    category: '91-baoliao',
    categoryName: '91爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20interior%20split%20in%20half%20concept%20wealth%20division%20dramatic%20lighting%20cold%20atmosphere%20minimalist%20modern%20interior%20tension%20mood%20cinematic%20photography%20dark%20shadows&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '91深度组',
    publishDate: '2026-07-05',
    viewCount: 2100000,
    commentCount: 67500,
    isHot: true,
    isTop: false,
    tags: ['明星离婚', '财产分割', '内幕揭秘'],
  },
  {
    id: '6',
    slug: 'variety-show-behind-scenes',
    title: '某热门综艺录制现场意外不断 嘉宾私下矛盾全面升级',
    excerpt: '据现场工作人员爆料，某卫视王牌综艺节目最新一期录制过程中状况连连。两位常驻嘉宾因游戏环节产生激烈冲突，节目组被迫中断录制长达两小时进行调解。',
    content: '',
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20recording%20studio%20set%20with%20cameras%20empty%20stage%20dramatic%20lighting%20behind%20the%20scenes%20professional%20production%20setup%20cinematic%20atmosphere%20tension&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '综艺吃瓜君',
    publishDate: '2026-07-04',
    viewCount: 876000,
    commentCount: 32400,
    isHot: false,
    isTop: false,
    tags: ['综艺', '嘉宾矛盾', '录制事故'],
  },
  {
    id: '7',
    slug: 'internet-celebrity-fake-products',
    title: '知名网红直播间售卖假货被实锤 粉丝集体维权要求退一赔三',
    excerpt: '一场由职业打假人发起的检测揭露了某头部带货主播销售假冒名牌产品的真相。检测报告显示多款"正品保证"的商品实际为高仿品，目前已有上千名消费者加入维权群。',
    content: '',
    category: 'wanghong-heiliao',
    categoryName: '网红黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=Fake%20luxury%20goods%20comparison%20authentic%20versus%20counterfeit%20products%20magnifying%20glass%20inspection%20dramatic%20lighting%20product%20photography%20dark%20background%20consumer%20protection%20concept&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '打假先锋',
    publishDate: '2026-07-04',
    viewCount: 1920000,
    commentCount: 78500,
    isHot: true,
    isTop: false,
    tags: ['直播带货', '假货', '消费者维权'],
  },
  {
    id: '8',
    slug: 'actor-tax-evasion',
    title: '某实力派演员涉嫌偷税漏税 金额巨大或面临刑事处罚',
    excerpt: '税务部门近日通报了一起演艺人员重大涉税违法案件。据悉该演员通过虚构业务、拆分合同等方式逃避缴纳税款，涉案金额高达数千万元，目前案件正在进一步调查中。',
    content: '',
    category: '911-baoliao',
    categoryName: '911爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Financial%20documents%20tax%20investigation%20concept%20dramatic%20lighting%20office%20scene%20dark%20atmosphere%20legal%20documents%20spread%20on%20desk%20cinematic%20photography%20serious%20mood%20professional&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '法治观察员',
    publishDate: '2026-07-03',
    viewCount: 2340000,
    commentCount: 89100,
    isHot: true,
    isTop: false,
    tags: ['偷税漏税', '演员', '税务稽查'],
  },
  {
    id: '9',
    slug: 'idol-secret-relationship',
    title: '当红偶像团体成员被曝秘密恋爱 经纪公司紧急公关删帖',
    excerpt: '粉丝通过私生图扒出某偶像团体人气成员与圈外人士的亲密合照。尽管经纪公司迅速启动公关机制删除相关帖文，但截图已在各大社交平台广泛传播。',
    content: '',
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=Kpop%20idol%20dancing%20on%20stage%20blurred%20background%20fans%20with%20lightsticks%20concert%20atmosphere%20dramatic%20stage%20lighting%20energetic%20performance%20youth%20culture%20vibrant%20ambient&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '饭圈前线',
    publishDate: '2026-07-03',
    viewCount: 1670000,
    commentCount: 54300,
    isHot: false,
    isTop: false,
    tags: ['偶像', '秘密恋爱', '公关删帖'],
  },
  {
    id: '10',
    slug: 'director-crew-abuse',
    title: '51独家：剧组工作人员实名举报某导演片场霸凌行为',
    excerpt: '51爆料网接到多位剧组工作人员实名举报，称某获奖导演在拍摄现场频繁对演员及工作人员进行语言暴力和人格侮辱，导致多人出现心理问题。',
    content: '',
    category: '51-baoliao',
    categoryName: '51爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20film%20set%20director%20chair%20spotlight%20dramatic%20shadows%20lonely%20atmosphere%20cinematic%20photography%20behind%20the%20scenes%20movie%20production%20dark%20moody%20tension&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '51正义组',
    publishDate: '2026-07-02',
    viewCount: 1430000,
    commentCount: 41500,
    isHot: true,
    isTop: false,
    tags: ['导演', '片场霸凌', '实名举报'],
  },
  {
    id: '11',
    slug: 'wechat-business-scam',
    title: '微商女王崩盘实录：数十万代理血本无归 创始人已潜逃海外',
    excerpt: '曾经风光无限的某微商品牌一夜之间全面崩盘。创始人被曝早已将资产转移至海外，留下数十万底层代理面对堆积如山的库存和血本无归的投资。',
    content: '',
    category: 'wanghong-heiliao',
    categoryName: '网红黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=Warehouse%20full%20of%20unsold%20products%20boxes%20stacked%20high%20dramatic%20lighting%20abandoned%20atmosphere%20industrial%20setting%20bankruptcy%20concept%20dark%20moody%20cinematic%20photography&width=800&height=500&seq=article-cover-11&orientation=landscape',
    author: '商业观察',
    publishDate: '2026-07-02',
    viewCount: 1130000,
    commentCount: 36200,
    isHot: false,
    isTop: false,
    tags: ['微商', '崩盘', '跑路'],
  },
  {
    id: '12',
    slug: 'singer-plagiarism-exposed',
    title: '91独家实锤：某金曲奖得主多首热门歌曲涉嫌抄袭',
    excerpt: '91爆料网联合专业音乐人进行技术比对后发现，某位多次获得金曲奖的歌手至少有五首热门单曲与国外小众音乐人作品高度相似，已超出"巧合"范畴。',
    content: '',
    category: '91-baoliao',
    categoryName: '91爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Music%20studio%20sheet%20music%20scattered%20on%20floor%20dramatic%20lighting%20recording%20equipment%20dark%20atmosphere%20creative%20process%20concept%20cinematic%20photography%20intellectual%20property%20mood&width=800&height=500&seq=article-cover-12&orientation=landscape',
    author: '91音乐组',
    publishDate: '2026-07-01',
    viewCount: 1780000,
    commentCount: 56700,
    isHot: true,
    isTop: false,
    tags: ['抄袭', '金曲奖', '音乐打假'],
  },
  {
    id: '13',
    slug: 'variety-show-rigged',
    title: '选秀节目投票造假内幕：技术员曝光后台数据修改全过程',
    excerpt: '一位曾就职于某选秀节目制作公司的前技术人员实名曝光了节目组操控观众投票的全过程。从后台数据修改到与经纪公司的利益交换，细节令人震惊。',
    content: '',
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=Computer%20server%20room%20data%20manipulation%20concept%20dark%20atmosphere%20blue%20LED%20lights%20mysterious%20technology%20setting%20dramatic%20shadows%20cinematic%20photography%20hacker%20aesthetic&width=800&height=500&seq=article-cover-13&orientation=landscape',
    author: '技术爆料人',
    publishDate: '2026-07-01',
    viewCount: 2010000,
    commentCount: 72100,
    isHot: true,
    isTop: false,
    tags: ['选秀', '投票造假', '技术曝光'],
  },
  {
    id: '14',
    slug: 'female-star-plastic-surgery',
    title: '某女星素颜照曝光与精修图差距惊人 粉丝直呼认不出',
    excerpt: '一组某知名女星的无修生图在社交平台疯传。照片中该女星面容与平时工作室发布的精修图存在明显差异，引发网友关于"真实与包装"的热烈讨论。',
    content: '',
    category: 'yule-bagua',
    categoryName: '娱乐八卦',
    coverImage: 'https://readdy.ai/api/search-image?query=Beauty%20contrast%20concept%20split%20face%20makeup%20versus%20natural%20dramatic%20lighting%20fashion%20magazine%20aesthetic%20soft%20portrait%20photography%20elegant%20dark%20background&width=800&height=500&seq=article-cover-14&orientation=landscape',
    author: '真相挖掘机',
    publishDate: '2026-06-30',
    viewCount: 1560000,
    commentCount: 48900,
    isHot: false,
    isTop: false,
    tags: ['素颜', '精修图', '反差'],
  },
  {
    id: '15',
    slug: 'company-ceo-scandal',
    title: '娱乐公司CEO被多名艺人联名举报 涉及合同欺诈与性骚扰',
    excerpt: '一场由旗下多名艺人联合发起的实名举报将某娱乐公司推上风口浪尖。举报信中详细列举了CEO多年来利用职务之便进行合同欺诈和职场性骚扰的多项证据。',
    content: '',
    category: '911-baoliao',
    categoryName: '911爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Corporate%20office%20empty%20executive%20chair%20dramatic%20lighting%20legal%20documents%20on%20desk%20dark%20corporate%20atmosphere%20scandal%20concept%20cinematic%20photography%20power%20and%20corruption%20mood&width=800&height=500&seq=article-cover-15&orientation=landscape',
    author: '911调查组',
    publishDate: '2026-06-30',
    viewCount: 2450000,
    commentCount: 93400,
    isHot: true,
    isTop: true,
    tags: ['CEO', '联名举报', '行业黑幕'],
  },
];

export const hotRankingArticles = [
  { id: '3', slug: '911-exclusive-insider', title: '某知名导演剧组内幕曝光 选角环节暗藏潜规则', viewCount: 1850000 },
  { id: '15', slug: 'company-ceo-scandal', title: '娱乐公司CEO被多名艺人联名举报', viewCount: 2450000 },
  { id: '8', slug: 'actor-tax-evasion', title: '某实力派演员涉嫌偷税漏税 金额巨大', viewCount: 2340000 },
  { id: '5', slug: '91-star-divorce-truth', title: '明星夫妻离婚内幕 财产分割暗藏玄机', viewCount: 2100000 },
  { id: '13', slug: 'variety-show-rigged', title: '选秀节目投票造假内幕 技术员实名曝光', viewCount: 2010000 },
  { id: '7', slug: 'internet-celebrity-fake-products', title: '知名网红直播间售卖假货被实锤', viewCount: 1920000 },
  { id: '12', slug: 'singer-plagiarism-exposed', title: '金曲奖得主多首热门歌曲涉嫌抄袭', viewCount: 1780000 },
];

export const heroHeadlines = [
  articles[0],
  articles[2],
  articles[14],
];